import { api, unwrap } from './client';

export async function listInvoices(page = 0, size = 100) {
  const res = await api.get(`/finance/invoices/paginated/all?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listInvoicesPaginated(page = 0, size = 10) {
  const res = await api.get(`/finance/invoices/paginated/all?page=${page}&size=${size}`);
  return unwrap(res);
}

export async function listInvoicesByCustomer(customerId, page = 0, size = 10) {
  const res = await api.get(`/finance/invoices/paginated/customer/${customerId}?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listOverdueInvoices(page = 0, size = 10) {
  const res = await api.get(`/finance/invoices/paginated/overdue?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listOverdueInvoicesPaginated(page = 0, size = 10) {
  const res = await api.get(`/finance/invoices/paginated/overdue?page=${page}&size=${size}`);
  return unwrap(res);
}

export async function listInvoicesByStatus(status, page = 0, size = 10) {
  const res = await api.get(`/finance/invoices/paginated/status/${status}?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listInvoicesByStatusPaginated(status, page = 0, size = 10) {
  const res = await api.get(`/finance/invoices/paginated/status/${status}?page=${page}&size=${size}`);
  return unwrap(res);
}

export async function listInvoicesByProject(projectId, page = 0, size = 10) {
  const res = await api.get(`/finance/invoices/paginated/project/${projectId}?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listInvoicesFilter(params) {
  const queryString = new URLSearchParams({ page: 0, size: 10, ...params }).toString();
  const res = await api.get(`/finance/invoices/paginated/filter?${queryString}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listInvoicesFilterPaginated(params) {
  const queryString = new URLSearchParams({ page: 0, size: 10, ...params }).toString();
  const res = await api.get(`/finance/invoices/paginated/filter?${queryString}`);
  return unwrap(res);
}

export async function getInvoice(id) {
  const res = await api.get(`/finance/invoices/${id}`);
  return unwrap(res);
}

export async function createInvoice(payload) {
  const res = await api.post('/finance/invoices', payload);
  return unwrap(res);
}

export async function updateInvoice(id, payload) {
  const res = await api.put(`/finance/invoices/${id}`, payload);
  return unwrap(res);
}

export async function updateInvoiceStatus(id, status) {
  const res = await api.patch(`/finance/invoices/${id}/status`, { status });
  return unwrap(res);
}

export async function deleteInvoice(id) {
  const res = await api.delete(`/finance/invoices/${id}`);
  return unwrap(res);
}

export async function downloadInvoicePdf(id, filename) {
  const response = await api.get(`/finance/invoices/${id}/pdf`, {
    responseType: 'blob'
  });
  const blob = response.data;
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename || `invoice_${id}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
}

export async function downloadInvoiceDocx(id, filename) {
  const response = await api.get(`/finance/invoices/${id}/docx`, {
    responseType: 'blob'
  });
  const blob = response.data;
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename || `invoice_${id}.docx`);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
}

export async function getInvoicePdfUrl(id) {
  const response = await api.get(`/finance/invoices/${id}/pdf`, {
    responseType: 'blob'
  });
  const blob = response.data;
  return window.URL.createObjectURL(blob);
}
